
// export const logout = ( state ) => {
// }

export const setOutputdetails = (state, outputdetails) => {
    state.outputdetails = outputdetails
}

export const setOutputdetailsSelectable = (state, outputdetails) => {
    state.outputdetailsSelectable = outputdetails
}

export const setOutputdetailsPaginated = (state, outputdetailsPaginatedData) => {
    state.outputdetailsPaginatedData = outputdetailsPaginatedData
}

export const setOutputdetail = (state, outputdetail) => {
    state.outputdetail = outputdetail
}

export const saveNewOutputdetails = (state, outputdetail) => {
    // state.outputdetails.unshift(outputdetail)
    state.createdData = outputdetail;
}

export const saveUpdatedOutputdetail = (state, outputdetail) => {
    // state.outputdetails.unshift(outputdetail)
    state.updatedData = outputdetail;
}

export const setDeleteOutputdetail = (state, outputdetail) => {
    state.deletedData = outputdetail
}

export const setOutputdetailIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setOutputdetailIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setOutputdetailIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setOutputdetailIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}

export const setOutputdetailIsSelecting = (state, isSelecting) => {
    state.isSelecting = isSelecting
}

export const setSelectedListOutputdetail = (state, outputdetails) => {
    state.selectedListData = outputdetails
}

export const saveNewMultipleOutputdetails = (state, outputdetail) => {
    // state.outputdetails.unshift(outputdetail)
    console.log('outputdetail');
    console.log(outputdetail);
    state.isSuccessMultiStoreOutputdetails = outputdetail;
}